var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMutualFunds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0771 14.0607C14.3774 14.5161 12.9401 13.9116 12.6308 12.7575C12.3216 11.6033 13.264 10.3611 14.9638 9.90566C17.6331 9.19043 19.3062 10.474 19.4299 10.9356C19.5536 11.3973 18.7464 13.3455 16.0771 14.0607Z",
    stroke: "#282829",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65531 10.0623C7.1793 10.9422 7.76814 12.3859 7.1707 13.4208C6.57325 14.4556 5.02851 14.6675 3.50452 13.7876C1.1113 12.4059 0.835818 10.3152 1.07479 9.90128C1.31377 9.48736 3.26209 8.68059 5.65531 10.0623Z",
    stroke: "#282829",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92188 21.899L9.92188 10.7959",
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0742 5.04749C12.0742 6.80724 11.1183 8.03906 9.92342 8.03906C8.72854 8.03906 7.77263 6.80724 7.77263 5.04749C7.77263 2.28404 9.44547 1.00012 9.92342 1.00012C10.4014 1.00012 12.0742 2.28404 12.0742 5.04749Z",
    stroke: "#282829",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1745 21.8994H5.66992",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutualFunds);
export default __webpack_public_path__ + "static/media/mutualFunds.387b676257ac97e40a792d80812424be.svg";
export { ForwardRef as ReactComponent };